import React, { useEffect } from "react";

//Components
import ContactNavbar from "../../components/ContactNavbar/ContactNavbar";
import Navbar from "../../components/Navbar/Navbar";
import WhatsappButton from "../../components/WhatsappButton/WhatsappButton";

const CreateCreditFirstScreen = ({ navbarData }) => {
  useEffect(() => {
    setInterval(() => {
      window.location.href = "https://portal.crediseguro.co/login";
    }, 500)
  }, []);

  return (
    <>
      <WhatsappButton />
      <ContactNavbar social={navbarData.data} />
      <Navbar />
      {/* <BodyCreateCreditFirstScreen buttons={dataBtnCCF.data} /> */}
    </>
  );
};

export default CreateCreditFirstScreen;
